import { ApolloClient, InMemoryCache, HttpLink, ApolloLink, concat } from '@apollo/client'

const GRAPHQL_SERVER_URL = process.env.REACT_APP_GRAPHQL_SERVER_URL || 'http://localhost:4000/'

const httpLink = new HttpLink({ uri: GRAPHQL_SERVER_URL })
const authLink = new ApolloLink((operation, forward) => {
  const headers = {}
  const token = localStorage.getItem('token')
  if (token) {
    headers.authorization = token
  }
  operation.setContext({
    headers
  })
  return forward(operation)
})

const client = new ApolloClient({
  link: concat(authLink, httpLink),
  cache: new InMemoryCache(),
})

export default client
